import { createContext } from "react"

import { undefinedFunctionWarning } from "../../utils/functions"
import { Tokens } from "../../interfaces/authentication"
import { User } from "../../types"

// ── Tokens stored in localStorage ─────────────────────────────────────────────

export const initialTokens: Tokens = {
    accessToken: null,
    refreshToken: null,
}

// ── State context shape ────────────────────────────────────────────────────────

export interface AuthenticationState extends Tokens {
    isAuthenticated: boolean
    isRefreshing: boolean
    /** Current user profile, fetched from /auth/me/ once authenticated. */
    user: User | null
    /** Convenience flag: true when the current user is a Django admin (is_staff). */
    isAdmin: boolean
}

export const initialStateContext: AuthenticationState = {
    accessToken: null,
    refreshToken: null,
    isAuthenticated: false,
    isRefreshing: false,
    user: null,
    isAdmin: false,
}

// ── Dispatch context shape ─────────────────────────────────────────────────────

export interface AuthenticationDispatch {
    login: (response: { access: string; refresh: string }) => void
    logout: () => void
}

const initialDispatchContext: AuthenticationDispatch = {
    login: undefinedFunctionWarning("login") as AuthenticationDispatch["login"],
    logout: undefinedFunctionWarning("logout") as AuthenticationDispatch["logout"],
}

// ── Contexts ───────────────────────────────────────────────────────────────────

export const AuthenticationStateContext = createContext<AuthenticationState>(initialStateContext)
export const AuthenticationDispatchContext = createContext<AuthenticationDispatch>(initialDispatchContext)
